import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useSelector } from 'react-redux';
import List from './List/List';
import { Routes, Route } from 'react-router-dom';
import useCurriculumElements from '../../../../../hooks/curriculum/useCurriculumElements';
import View from './View/View';
import ButtonStartIcon from '../../../../button/ButtonStartIcon';
import ElementChildrenDialog from './DialogChildren/DialogChildren';
import useCurriculumElementsStructure from '../../../../../hooks/curriculum/useCurriculumElementsStructure';

const Elements = () => {
  const [modal, setModal] = useState(null);

  const element = useSelector((state) => state?.curriculum?.elements || {});
  const { isLoadingList } = useCurriculumElements();
  const { isLoadingList: isLoadingListES } = useCurriculumElementsStructure();
  const elementsStructure = useSelector((state) => state?.curriculum?.elementsStructure || {});
  const permission = useSelector((state) =>
    state?.session?.permissions ? state?.session?.permissions['curriculum-elements'] || {} : {}
  );
  return (
    <>
      <Box className='bg-primary text-primary-foreground px-4 py-1 flex gap-4 items-center justify-between sticky left-0px top-0 z-10 h-8'>
        <Typography variant='subtitle1' className='uppercase'>
          Elements {elementsStructure?.name ? ` - ${elementsStructure?.name}` : ''}
        </Typography>
        <div className='flex gap-4'>
          {permission['created'] && (
            <ButtonStartIcon
              color='secondary'
              variant='contained'
              startIcon={['fas', 'plus']}
              onClick={() =>
                setModal({
                  type: 'create',
                  form: {}
                })
              }
            >
              Create
            </ButtonStartIcon>
          )}
        </div>
      </Box>
      <Routes>
        <Route
          index
          element={
            <List
              isLoading={isLoadingList || isLoadingListES}
              listTemp={element?.children || []}
              name={elementsStructure?.name}
            />
          }
        />
        <Route path=':elementId' element={<View />} />
      </Routes>
      {modal && (
        <ElementChildrenDialog
          title='Create child element'
          show={!!modal}
          onClose={() => setModal(null)}
          type={modal.type}
          data={modal.form}
        />
      )}
    </>
  );
};

export default Elements;
